import type { MapPosition } from "@locators/components/shared/hooks/useFlotiqStores/useFlotiqStores.types";
import { useSimpleStoreLocator } from "@locators/components/shared/hooks/useSimpleStoreLocator";
import type { StoreLocatorReturnType } from "@locators/components/shared/hooks/useStoreLocator";

import { ACTIVE_MARKER, DEFAULT_MARKER_DARK, DEFAULT_MARKER_LIGHT } from "../events-locator-icons";
import type { EventsLocatorProps } from "../types";

import { useEventsStores } from "./useEventsStores";

export type EventsLocatorReturnType = StoreLocatorReturnType & {
  mapPosition: MapPosition | undefined;
};

export const useEventsLocator = (props: EventsLocatorProps, theme: "dark" | "light"): EventsLocatorReturnType => {
  const {
    defaultLat,
    defaultLng,
    defaultZoom,
    storesLimit,
    selectedDateRange,
    isOpeningHoursBreaksEnabled = false,
    mapProviderOverride,
    mapInactivityTimeout,
  } = props;
  const defaultStoreIcon = theme === "dark" ? DEFAULT_MARKER_DARK : DEFAULT_MARKER_LIGHT;

  const eventsStoresData = useEventsStores({ storesLimit, selectedDateRange });

  const locatorData = useSimpleStoreLocator({
    defaultLat,
    defaultLng,
    defaultZoom,
    isOpeningHoursBreaksEnabled,
    mapProviderOverride,
    mapInactivityTimeout,
    theme,
    storesData: {
      stores: eventsStoresData.eventsStores,
      activeStoreId: eventsStoresData.activeStoreId,
      getStores: eventsStoresData.getEventsStores,
      handleSelectStore: eventsStoresData.handleSelectStore,
      getUserMarkerPosition: eventsStoresData.getUserMarkerPosition,
      userMarkerPosition: eventsStoresData.userMarkerPosition,
    },
    defaultStoreIcon,
    activeStoreIcon: ACTIVE_MARKER,
    translationPrefix: "events",
  });

  return {
    ...locatorData,
    filtersEnabled: true,
    isFiltersAvailable: true,
    newFiltersNumber: 1,
    translationPrefix: "events",
    mapPosition: eventsStoresData.mapPosition,
  };
};
